import { makeSimpleGetRequest } from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import { LoadingMessage } from "./types";

export const getLoadingMessage = async (): Promise<LoadingMessage[]> =>
  await makeSimpleGetRequest<LoadingMessage[]>(
    `${ORDERBOOK_URL}/loading-messages/`,
  );
